import React, { useEffect, useRef, useState } from "react";
import applogo from "../assets/logo.svg";
import "../styles/layouts/header.scss";
import {
  Container, ListItem, List, IconButton, Menu, MenuItem, Typography, Stack, Tooltip,
  Dialog,
  Button,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation } from "react-router-dom";
import arrow from "../assets/icons/right-arrow.svg";
import cart_icon from "../assets/icons/cart.svg";
import notification_icon from "../assets/icons/notification.svg";
import user_icon from "../assets/icons/user.svg";
import Login from "../../User/components/Login";
import Register from "../../User/components/Register";
import LivePopup from "../components/LivePopup";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context/Context";
import live from '../assets/livesoon-6.svg'
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import instance from "../../Utils/api";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const Header = () => {
  const navigate = useNavigate();
  const { userName, setUserDisplay } = useGlobalContext();
  const { cartLength } = useGlobalContext();
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openLogoutPopup, setOpenLogoutPopup] = useState(false);

  // const [cartLength, setCartLength] = useState(0);

  // const fetchCartLength = async () => {
  //   try {
  //     const response = await instance.get("/Cart/getCart");
  //     const items = response?.data?.data?.items || [];
  //     console.log("items", items);

  //     setCartLength(items?.length);
  //   } catch (error) {
  //     console.error("Error fetching cart length:", error);
  //   }
  // };
  // useEffect(() => {
  //   fetchCartLength();
  // }, []);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isLivePopup, setIsLivePopup] = useState(false);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [notificationAnchor, setNotificationAnchor] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const isNotificationMenuOpen = Boolean(notificationAnchor);
  const handleNavbarToggle = () => setIsNavbarOpen(!isNavbarOpen);
  const handleOpenLoginModal = () => {
    setIsNavbarOpen(false);
    setIsLoginModalOpen(true);
  };
  const handleCloseLoginModal = () => setIsLoginModalOpen(false);
  const handleCloseRegisterModal = () => setIsRegisterModalOpen(false);
  const handleLivePopupCloseModal = () => setIsLivePopup(false);
  const menuRef = useRef();
  const loaderRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isNavbarOpen && menuRef.current && !menuRef.current.contains(event.target)) {
        setIsNavbarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isNavbarOpen]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    setUserDisplay(false);
    navigate("/");
  };

  const fetchNotifications = async (page = 1, limit = 10) => {
    try {
      const response = await instance.get("/Notifications/getUserNotification", {
        params: { page, limit },
      });

      return {
        list: response?.data?.data || [],
        pagination: response?.data?.pagination || {},
      };
    } catch (error) {
      console.error("Error fetching notifications:", error);
      return { list: [], pagination: {} };
    }
  };

  const loadMore = async () => {
    if (loading || !hasMore) return;

    setLoading(true);

    try {
      const { list, pagination } = await fetchNotifications(page);

      if (list.length < 10) {
        setHasMore(false);
      }

      setNotifications((prev) => [...prev, ...list]);

      setPage((prev) => prev + 1);
    } catch (err) {
      console.error("Error loading notifications:", err);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!loaderRef.current) return;

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore && !loading) {
        loadMore();
      }
    });

    observer.observe(loaderRef.current);

    return () => observer.disconnect();
  }, [loaderRef.current, hasMore, loading]);



  // useEffect(() => {
  //   loadMore();
  // }, []);


  return (
    <>

      <section className="header">
        <section className="service-announcement">
          <div className="marquee">
            <div className="marquee-content">
              🚚 Currently we are serving only In Hyderabad  ✨&nbsp;&nbsp;&nbsp;

            </div>
          </div>
        </section>
        <Container maxWidth="xl">
          <div className="navbar">

            <div className="navbar-menu">
              <List>
                <Link to="/home">
                  <ListItem>
                    <img src={applogo} alt="applogo" />
                  </ListItem>
                </Link>
              </List>
            </div>

            <div className="navbar-left">
              <div ref={menuRef} className={`navbar-links ${isNavbarOpen ? "active" : ""}`}>
                {isNavbarOpen ? <div className="close-cross-btn" onClick={handleNavbarToggle}> <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey,
                  }}
                >
                  <CloseIcon />
                </IconButton></div> : null}
                <List className="menu-links1">
                  <Link to="/home" style={{ marginLeft: "20px" }}>
                    <ListItem
                      className={splitLocation[1] === "home" ? "active" : ""}
                    >
                      Home
                    </ListItem>
                  </Link>
                  <Link to="/catalogue">
                    <ListItem
                      className={splitLocation[1] === "catalogue" ? "active" : ""}
                    >
                      Catalogue
                    </ListItem>
                  </Link>
                  {/* <Link to="/Categories">
                <ListItem className={splitLocation[1] === "Categories" ? "active" : ""}>
                  Categories
                </ListItem>
              </Link> */}
                  <Link to="/about">
                    <ListItem
                      className={splitLocation[1] === "about" ? "active" : ""}
                    >
                      About Us
                    </ListItem>
                  </Link>
                  <a href="https://play.google.com/store/apps/details?id=com.tailor4u.user&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                    <ListItem>Download App</ListItem>
                  </a>
                </List>
              </div>

              <div className="Notification_menu">
                <Link>
                  <List>
                    <ListItem>
                      <img
                        onClick={(e) => setNotificationAnchor(e.currentTarget)}
                        src={notification_icon}
                        alt="notification_icon"
                      />
                      {/* <span className="cart-badge">{notifications.length}</span>
                          <span className="cart-count-mobile">{notifications.length}</span> */}
                    </ListItem>
                  </List>
                </Link>

                <div
                  className={`notification-dropdown ${isNotificationMenuOpen ? "open" : ""}`}
                  ref={menuRef}
                >
                  <div className="notif-header">
                    <h3>Notifications</h3>
                    <span className="close-btn" onClick={() => setNotificationAnchor(null)}>
                      ✖
                    </span>
                  </div>

                  <div className="notif-list">
                    {notifications.length === 0 && (
                      <p className="no-notif">No notifications</p>
                    )}

                    {notifications.map((item, index) => (
                      <div key={index} className="notif-item">
                        <strong>{item.title}</strong>
                        <span className="message">{item.message}</span>
                        <small className="date">
                          <AccessTimeIcon style={{ fontSize: "14px", color: "#e37b00" }} />
                          {new Date(item.createdAt).toLocaleDateString("en-GB")}
                        </small>
                      </div>
                    ))}

                    {loading && <p className="loading">Loading...</p>}

                    <div ref={loaderRef} className="loader-box"></div>
                  </div>
                </div>
              </div>

              <div className="cart_menu">
                <Link to="/mycart">
                  <List>
                    <ListItem>
                      <img src={cart_icon} alt="cart_icon" />
                      {token && (
                        <>
                          <span className="cart-badge">{cartLength}</span>
                          <span className="cart-count-mobile">{cartLength}</span>
                        </>
                      )}
                    </ListItem>
                  </List>
                </Link>
              </div>

              <div className="profile_menu">
                <IconButton
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={token ? handleClick : handleOpenLoginModal}
                >
                  {token ? (
                    <div className="menu_toggle">
                      {/* <AccountCircleIcon size={15} color="#fff" /> */}
                      <PersonPinIcon size={15} color="#fff" />
                      <Typography title={userName?.name}>
                        {userName?.name
                          ? userName?.name.length > 20
                            ? `${userName.name.slice(0, 20)}...`
                            : userName.name
                          : ""}
                      </Typography>
                      {open ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </div>
                  ) : (
                    <div className="menu_toggle">
                      {/* <img src={user_icon} alt="user_icon" /> */}
                      {/* <AccountCircleIcon size={15} color="#fff" /> */}
                      <PersonPinIcon size={15} color="#fff" />
                      <Typography >
                        Login / Register
                      </Typography>
                    </div>
                  )}
                </IconButton>

                <Menu
                  className="filter-options1"
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={token ? open : false}
                  onClose={handleClose}
                >
                  <MenuItem onClick={() => { navigate("/profile/account"); handleClose(); }}>
                    Account Settings
                  </MenuItem>
                  <MenuItem onClick={() => { navigate("/profile/address"); handleClose(); }}>
                    My Address
                  </MenuItem>
                  <MenuItem onClick={() => { navigate("/profile/myorders"); handleClose(); }}>
                    My Orders
                  </MenuItem>
                  <MenuItem onClick={() => { navigate("/profile/myinteraction"); handleClose(); }}>
                    My Consultations
                  </MenuItem>
                  <MenuItem onClick={() => { setOpenLogoutPopup(true); handleClose(); }}>
                    Logout
                  </MenuItem>
                </Menu>
              </div>

              <div className="drawer_toggle">
                <IconButton onClick={handleNavbarToggle}>
                  <MenuIcon />
                </IconButton>
              </div>
            </div>

          </div>
        </Container>

        <Login
          isLoginModalOpen={isLoginModalOpen}
          handleCloseLoginModal={handleCloseLoginModal}
        />
        <Register
          isRegisterModalOpen={isRegisterModalOpen}
          handleCloseRegisterModal={handleCloseRegisterModal}
        />
        <LivePopup
          isLivePopup={isLivePopup}
          handleLivePopupCloseModal={handleLivePopupCloseModal}
        />
        {isNavbarOpen && (
          <div className="body-overlay" onClick={handleNavbarToggle}></div>
        )}
      </section >
      <Dialog
        open={openLogoutPopup}
        onClose={() => setOpenLogoutPopup(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "20px",
            width: "420px",
          },
        }}
      >
        <div style={{ textAlign: "center", padding: "10px 0" }}>
          <h2 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }}>
            Logout Confirmation
          </h2>

          <p style={{ marginTop: "12px", fontSize: "16px", color: "#555" }}>
            Are you sure you want to logout?
          </p>

          <div
            style={{
              marginTop: "25px",
              display: "flex",
              justifyContent: "center",
              gap: "20px",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => setOpenLogoutPopup(false)}
              sx={{
                width: "120px",
                borderRadius: "10px",
                textTransform: "none",
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              color="error"
              onClick={handleLogout}
              sx={{
                width: "120px",
                borderRadius: "10px",
                textTransform: "none",
              }}
            >
              Logout
            </Button>
          </div>
        </div>
      </Dialog>

    </>
  );
};

export default Header;
